const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Takk for registreringen",
      content:
        "Kjære<br/>Takk for at du registrerte deg. Vi er glade for å informere om at registreringen din på BRIDGESTONE PLUS er vurdert og godkjent.<br/>Vi håper BRIDGESTONE PLUS gir deg suksess og verdifulle muligheter, og vi ser frem til videre samarbeid.<br/>Med vennlig hilsen,<br/>BRIDGESTONE PLUS-teamet",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Takk for registreringen",
      content:
        "Kjære<br/>Takk for at du registrerte deg. Vi er glade for å informere om at registreringen din på BRIDGESTONE PLUS er vurdert og godkjent.<br/>Vi håper BRIDGESTONE PLUS gir deg suksess og verdifulle muligheter, og vi ser frem til videre samarbeid.<br/>Med vennlig hilsen,<br/>BRIDGESTONE PLUS-teamet",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
